import apiClient from './client'

export interface UserManutencao {
  id: number
  email: string
  name: string
  nivel_acesso: number | null
  is_active: boolean
  login_thor?: string | null
  iduser_thor?: number | null
  descricao_superadmin?: string | null
  descricao_usuario?: string | null
  grupos: Array<{ id: number; nome: string }>
  empresas: Array<{ id: number; nome: string; grupo_id: number }>
  created_at: string
  updated_at: string | null
}

export type UserManutencaoSortField =
  | 'id'
  | 'name'
  | 'email'
  | 'nivel_acesso'
  | 'is_active'
  | 'login_thor'
  | 'iduser_thor'
  | 'descricao_usuario'
  | 'created_at'
  | 'updated_at'

export type UserManutencaoSortDirection = 'asc' | 'desc'

export interface UserManutencaoCreate {
  email: string
  name: string
  password: string
  nivel_acesso?: number
  is_active?: boolean
  descricao_superadmin?: string
  descricao_usuario?: string
  grupo_ids: number[]
  empresa_ids?: number[]
  login_thor?: string | null
  iduser_thor?: number | null
}

export interface UserManutencaoUpdate {
  name?: string
  nivel_acesso?: number
  is_active?: boolean
  descricao_superadmin?: string
  descricao_usuario?: string
  login_thor?: string
  iduser_thor?: number
}

export interface ManutencaoFilters {
  grupo_id?: number
  empresa_id?: number
  nivel_acesso?: number
  is_active?: boolean
  email?: string
  nome?: string
  skip?: number
  limit?: number
  sort_by?: UserManutencaoSortField
  sort_direction?: UserManutencaoSortDirection
}

export interface ManutencaoListResponse {
  usuarios: UserManutencao[]
  total: number
  skip: number
  limit: number
}

export const usuariosManutencaoApi = {
  list: async (filters?: ManutencaoFilters): Promise<ManutencaoListResponse> => {
    const params: Record<string, unknown> = {
      skip: filters?.skip || 0,
      limit: filters?.limit || 100,
    }
    if (filters?.grupo_id) params.grupo_id = filters.grupo_id
    if (filters?.empresa_id) params.empresa_id = filters.empresa_id
    if (filters?.nivel_acesso !== undefined) params.nivel_acesso = filters.nivel_acesso
    if (filters?.is_active !== undefined) params.is_active = filters.is_active
    if (filters?.email) params.email = filters.email
    if (filters?.nome) params.nome = filters.nome
    if (filters?.sort_by) params.sort_by = filters.sort_by
    if (filters?.sort_direction) params.sort_direction = filters.sort_direction

    const response = await apiClient.get<ManutencaoListResponse>('/usuarios/manutencao', { params })
    return response.data
  },

  get: async (id: number): Promise<UserManutencao> => {
    const response = await apiClient.get<UserManutencao>(`/usuarios/manutencao/${id}`)
    return response.data
  },

  create: async (data: UserManutencaoCreate): Promise<UserManutencao> => {
    const response = await apiClient.post<UserManutencao>('/usuarios/manutencao', data)
    return response.data
  },

  update: async (id: number, data: UserManutencaoUpdate): Promise<UserManutencao> => {
    const response = await apiClient.put<UserManutencao>(`/usuarios/manutencao/${id}`, data)
    return response.data
  },

  toggleStatus: async (id: number, active: boolean): Promise<void> => {
    await apiClient.patch(`/usuarios/manutencao/${id}/status`, { is_active: active })
  },

  vincularEmpresa: async (usuarioId: number, empresaId: number): Promise<void> => {
    await apiClient.post(`/usuarios/manutencao/${usuarioId}/empresas/${empresaId}`)
  },

  desvincularEmpresa: async (usuarioId: number, empresaId: number): Promise<void> => {
    await apiClient.delete(`/usuarios/manutencao/${usuarioId}/empresas/${empresaId}`)
  },

  desvincularGrupo: async (usuarioId: number, grupoId: number): Promise<void> => {
    await apiClient.delete(`/usuarios/manutencao/${usuarioId}/grupos/${grupoId}`)
  },
}

